module.exports = __webpack_public_path__ + "static/media/locasty-logo.56db08a1.svg";